(() => {
 document.querySelectorAll('.lp-gallery').forEach(gallery => {
  if(gallery.dataset.ready)return;gallery.dataset.ready='true';
  gallery.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
   const main=gallery.querySelector('.lp-main img');main.src=button.dataset.gallerySrc;main.alt=button.querySelector('img').alt;
   gallery.querySelectorAll('button').forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});
  }));
 });
 document.querySelectorAll('.lc-catalog').forEach(catalog=>{
  if(catalog.dataset.ready)return;catalog.dataset.ready='true';
  const selectors=catalog.querySelectorAll('select');const search=catalog.querySelector('[type=search]');
  const filter=()=>{let count=0;catalog.querySelectorAll('[data-catalog-card]').forEach(card=>{let show=Array.from(selectors).every(s=>!s.value||card.dataset[s.name]===s.value)&&(!search||card.textContent.toLowerCase().includes(search.value.toLowerCase()));card.hidden=!show;if(show)count++;});catalog.querySelector('[role=status]').textContent=count+' pieces';};
  selectors.forEach(select=>{
   select.addEventListener('change',filter);
   const label=select.parentElement;
   const menu=document.createElement('details');menu.className='lc-select';
   const summary=document.createElement('summary');
   const title=document.createElement('span');title.textContent=select.selectedOptions[0].textContent;
   summary.append(title);menu.append(summary);
   const panel=document.createElement('div');panel.className='lc-select-panel';
   Array.from(select.options).forEach(option=>{
    const choice=document.createElement('button');choice.type='button';choice.textContent=option.textContent;choice.setAttribute('aria-label',option.textContent);
    choice.setAttribute('aria-pressed',String(option.selected));
    choice.addEventListener('click',()=>{select.value=option.value;title.textContent=option.textContent;panel.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===choice)));select.dispatchEvent(new Event('change',{bubbles:true}));menu.open=false;summary.focus();});panel.append(choice);
   });
   menu.append(panel);select.hidden=true;label.append(menu);
   // Remove the label wrapper: the custom disclosure contains independent buttons.
   const group=document.createElement('div');group.className='lc-filter-group';
   while(label.firstChild)group.append(label.firstChild);label.replaceWith(group);
   menu.addEventListener('toggle',()=>{if(menu.open)catalog.querySelectorAll('.lc-select').forEach(other=>{if(other!==menu)other.open=false;});});
   document.addEventListener('click',e=>{if(!menu.contains(e.target))menu.open=false;});
   menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;summary.focus();}});
  });search?.addEventListener('input',filter);filter();
 });
})();
